/*
 * Christmas custom photo upload: progress feedback without replacing Shopify's
 * native multipart form request. File input stays enabled for submission.
 * Repeated submissions are prevented until navigation completes.
 */
(() => {
  if (window.__svChristmasPhotoFeedbackInstalled) return;
  window.__svChristmasPhotoFeedbackInstalled = true;

  const isIt = (document.documentElement.lang || '').toLowerCase().startsWith('it');
  const productSelector = 'product-form-component[data-product-id="11350876619095"]';
  const originalButtonHtml = new WeakMap();

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest(productSelector)) return;

    const petPhoto = form.querySelector('input[type="file"][name="properties[Pet Photo]"]');
    if (!(petPhoto instanceof HTMLInputElement)) return;

    if (form.dataset.svPhotoUploadPending === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    // Native required-field validation runs before submit; never submit
    // an empty photo field or interrupt the upload's multipart encoding.
    if (!petPhoto.files?.length || !form.checkValidity()) return;

    const button = form.querySelector('button[type="submit"][name="add"]');
    if (button instanceof HTMLButtonElement) {
      originalButtonHtml.set(button, button.innerHTML);
      button.textContent = isIt ? 'Caricamento della foto…' : 'Uploading your pet photo…';
      button.classList.add('sv-christmas-submit--uploading');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
    }

    const message = form.querySelector('[data-sv-upload-feedback]');
    if (message instanceof HTMLElement) {
      message.hidden = false;
      message.textContent = isIt ? 'Caricamento sicuro della foto… Potrebbero volerci alcuni secondi. Non premere di nuovo.' : 'Uploading your pet photo securely… This may take a few seconds. Please do not click again.';
    }
    form.dataset.svPhotoUploadPending = 'true';
    // Do not preventDefault() here: Shopify must handle the real file upload.
  }, true);

  // The browser may restore the product page from back-forward cache
  // after a shopper visits the cart. Restore its normal button state.
  window.addEventListener('pageshow', () => {
    for (const form of document.querySelectorAll(productSelector + ' form')) {
      if (form.dataset.svPhotoUploadPending !== 'true') continue;
      delete form.dataset.svPhotoUploadPending;

      const button = form.querySelector('button[type="submit"][name="add"]');
      if (button instanceof HTMLButtonElement) {
        button.innerHTML = originalButtonHtml.get(button) || (isIt ? 'Aggiungi al carrello' : 'Add to cart');
        button.classList.remove('sv-christmas-submit--uploading');
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
      }

      const message = form.querySelector('[data-sv-upload-feedback]');
      if (message instanceof HTMLElement) message.hidden = true;
    }
  });
})();
